import { useState } from 'react';
import { useI18n } from '@/hooks/useI18n';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Lock } from 'lucide-react';

interface PasswordGateProps {
  onSubmit: (password: string) => void;
  error?: string;
  isLoading?: boolean;
}

export const PasswordGate = ({ onSubmit, error, isLoading }: PasswordGateProps) => {
  const { t } = useI18n();
  const [password, setPassword] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password.trim()) {
      onSubmit(password);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full p-8 bg-white rounded-lg shadow-lg">
        <Lock className="h-12 w-12 mx-auto mb-4 text-gray-600" />
        <h1 className="text-2xl font-bold text-center mb-2">
          {t('sharedProposal.passwordRequired')}
        </h1>
        <p className="text-gray-600 text-center mb-6">
          {t('sharedProposal.enterPassword')}
        </p>
        
        <form onSubmit={handleSubmit}>
          <Input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder={t('sharedProposal.passwordPlaceholder')}
            className="mb-4"
            autoFocus
          />
          {error === 'invalid_password' && (
            <p className="text-red-600 text-sm mb-4">
              {t('sharedProposal.invalidPassword')}
            </p>
          )}
          {error === 'password_required' && (
            <p className="text-red-600 text-sm mb-4">
              {t('sharedProposal.passwordRequired')}
            </p>
          )}
          {error === 'network_error' && (
            <p className="text-red-600 text-sm mb-4">
              {t('common.networkError')}
            </p>
          )}
          {error && !['invalid_password', 'password_required', 'network_error'].includes(error) && (
            <p className="text-red-600 text-sm mb-4">
              {t('sharedProposal.genericError')}
            </p>
          )}
          <Button
            type="submit"
            disabled={!password.trim() || isLoading}
            className="w-full"
          >
            {isLoading ? t('common.loading') : t('sharedProposal.accessButton')}
          </Button>
        </form>
      </div>
    </div>
  );
};
